import { createReducer } from "typesafe-actions";

import { GuideUserStatus } from "@mapmycustomers/shared/types/entity";

import { Actions, refreshGuidesStatus } from "./actions";

export interface OnboardingState {
  guidesStatus: GuideUserStatus[];
}

const initialState: OnboardingState = {
  guidesStatus: [],
};

const onboarding = createReducer<OnboardingState, Actions>(initialState).handleAction(
  refreshGuidesStatus.success,
  (state, { payload }) => ({
    ...state,
    guidesStatus: payload.guidesStatus,
  })
);

export * from "./selectors";
export type OnboardingActions = Actions;
export default onboarding;
